import { useQuery } from "@tanstack/react-query";

import { Deal } from "@Types/deal";
import { HttpQuery, PaginatedResult } from "@Types/http";
import { MutationError } from "@Types/index";
import { getApplications, getApplication } from "@Http/deals";

const useGetDeals = (query?: HttpQuery) => {
  const queryKey = ["deals", query];

  const { data, isLoading, isFetching, error } = useQuery<
    PaginatedResult<Deal[]>,
    MutationError,
    PaginatedResult<Deal[]>
  >({
    queryKey: queryKey,
    queryFn: getApplications(query),
  });

  return {
    data: data?.docs ?? [],
    totalPages: data?.totalPages ?? 0,
    totalDocs: data?.totalDocs ?? 0,
    isLoading,
    isFetching,
    error,
  };
};

export const useGetDeal = (id: string, enabled = true) => {
  const queryKey = ["deal", id];

  const { data, isLoading, error } = useQuery<Deal, MutationError, Deal>({
    queryKey,
    queryFn: getApplication(id),
    enabled,
  });
  return {
    data,
    isLoading,
    error,
  };
};

export default useGetDeals;
